export default class UtilsMessage {

    convertEmailLinks(message) {

        // for "[http://...] (http://...)" pattern
        const regexp = new RegExp(/\[(.*?)\]\((.*?)\)/, 'gmis');
        message = _.replace(message, regexp, (...match)=>{
            const squareLink = match[1];
            const roundLink = match[2];

            // check if links are the same
            if (squareLink && roundLink && squareLink.trim() === roundLink.trim())  return roundLink.trim();
            else                                                                    return match[0]; // no changes if links are different
        })

        // for "http://... <http://...>" pattern
        const regexp2 = new RegExp(/\<((https?:\/\/|www)(.*?))\>/, 'gmis');
        const matches = [...message.matchAll(regexp2)];

        _.map(matches, match=>{
            if (gd.utils.isValidURL(match[1])) {
                // console.log("url=", match[1])
                // tut est' problema pochemu to ono prpuskaet
                // vot takoe as URL url= image001.png
                try {
                    const url = new URL(match[1]);
                    message = _.replace(message, match[1] + " " + match[0], match[1]);
                    message = _.replace(message, url.host + " " + match[0], match[1]);
                    message = _.replace(message, match[1] + "" + match[0], match[1]);
                    message = _.replace(message, url.host + "" + match[0], match[1]);
                } catch(err) {
                    console.log(err)
                }

            }
        })

        return message;
    }
};